// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3V36e","content":"LayoutSettings_content__1qan-"};